/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'

const INTERVENTION_BASE_LINK = '/admin/interventions'

export function getInterventionCreateLink (params?: Record<string, unknown>) {
  return `${INTERVENTION_BASE_LINK}/create?${stringify(params)}`
}

export function getInterventionLink (id: number) {
  return `${INTERVENTION_BASE_LINK}/${id}/edit`
}

export function getInterventionLinkTemplate () {
  return `${INTERVENTION_BASE_LINK}/{id}/edit`
}

export function getInterventionListLink (params?: Record<string, unknown>) {
  return `${INTERVENTION_BASE_LINK}?${stringify(params)}`
}
